import React, { Component } from "react"
import { Link, Redirect } from "react-router-dom"
import { Animated } from "react-animated-css"
import auth from '../../utils/auth'
import cfg from '../../utils/config'
import axios from 'axios'
import helper from '../../utils/helper'
import './style.css'

const CODIGO_TAMANHO = 6

class Login extends Component {

    state = {
        email: "",
        password: "",
        conexao_persistente: false,
        redirectToReferrer: false,
        showmessage: false,
        logomarca: null,
        loadcomplete: false,
        loading: false,
        config: { "titulo_sistema": "Hidroview v4", "descricao_sistema": "", "logomarca": "logomarcas/kronlogo.png", "descricao_horario_atendimento": "Seg. a Sex. das 8:00 às 18:00 ", "email_contato": "contato@ghidro.com.br ", "endereco": "Rua Carlos Ferrari, 18, Sala 610 – Centro – Garça/SP", "facebook": "https://www.facebook.com/ghidromonitoramento/", "link_criar_conta": "https://www.ghidro.com.br", "linkedin": "https://www.linkedin.com/company/g-hidro-monitoramento/", "telefone": "(14) 98161-0616", "youtube": "https://www.youtube.com/channel/UCj1BOaOQTuPMrTgPewSwgvw" },
        cores: { "degrade_top_primeira_cor": "#F44E3B", "degrade_top_segunda_cor": "#2f577b", "back_logomarca": "#37424A", "back_menu_lateral": "#37424A", "fonte_menu_lateral": "#c7c7c7", "fonte_grupo_menu_lateral": "#c7c7c7" },
        see_password: false,
        step: 1,
        codigoDigits: Array(CODIGO_TAMANHO).fill(""),
        msg_erro_codigo: ""
    }

    codigoRefs = Array.from({ length: CODIGO_TAMANHO }, () => React.createRef())

    componentWillMount = () => {
        this.setFavicon(null)
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
        let domain = window.location.host

        axios.get(cfg.base_api_url + cfg.api_v2 + `/configuracao-login/?domain=${domain}`, config_me)
            .then((config) => {
                let cores = ''
                let logomarca = ''
                let config_nova = ''

                cores = config.data.cores
                logomarca = config.data.config.logomarca
                config_nova = config.data.config
                document.title = config.data.config.titulo_sistema ?? "Afira"

                if (config.data.config?.favicon) {
                    this.setFavicon(config.data.config?.favicon)
                } else {
                    this.setFavicon("/favicon.ico")
                }

                this.setState({ cores: cores, opacity: 1, logomarca: logomarca, loadcomplete: true, config: config_nova })
            })
            .catch(console.error)
    }

    setFavicon = (link = null) => {
        let favicon = document.querySelector('link[rel="icon"]')

        if (favicon !== null) {
            favicon.href = link
        } else {
            favicon = document.createElement("link")
            favicon.rel = "icon"
            favicon.href = link
            document.head.appendChild(favicon)
        }
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleSubmit(e)
        }
    }

    validarCodigo2fa = () => {
        if (this.state.loading) return

        const requestURL = cfg.base_api_url + cfg.api_v2 + '/2fa/validar/'
        const config = { headers: { 'Content-Type': 'application/json' } }

        let body = {
            email: this.state.email,
            codigo: this.state.codigoDigits.join('')
        }

        this.setState({ loading: true })

        axios.post(requestURL, body, config)
            .then(() => {
                this.generateToken()
                    .then(() => {
                        this.getDataUser()
                    })
                    .catch(() => {
                        this.setState({ msg_erro_codigo: 'Não foi possível concluir o login, tente novamente.', loading: false })
                    })
            })
            .catch((error) => {
                this.setState({ msg_erro_codigo: error?.response?.data?.message || 'Código inválido, tente novamente.', loading: false })
            })
    }

    cancelar2fa = () => {
        this.setState({
            step: 1,
            codigoDigits: Array(CODIGO_TAMANHO).fill(""),
            msg_erro_codigo: ""
        })
    }

    handleCodigoDigitChange = (index, e) => {
        let valor = e.target.value.slice(-1)
        let codigoDigits = [...this.state.codigoDigits]
        codigoDigits[index] = valor

        this.setState({ codigoDigits })

        if (valor && index < CODIGO_TAMANHO - 1) {
            const proximo = this.codigoRefs[index + 1].current
            if (proximo) proximo.focus()
        }
    }

    handleCodigoDigitKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !this.state.codigoDigits[index] && index > 0) {
            const anterior = this.codigoRefs[index - 1].current
            if (anterior) anterior.focus()
        } else if (e.key === 'Enter') {
            this.validarCodigo2fa()
        }
    }

    handleCodigoPaste = (index, e) => {
        e.preventDefault()

        let pasted = (e.clipboardData || window.clipboardData).getData('text').trim()
        if (!pasted) return

        let chars = pasted.split('')
        let codigoDigits = [...this.state.codigoDigits]

        for (let i = 0; i < chars.length && (index + i) < CODIGO_TAMANHO; i++) {
            codigoDigits[index + i] = chars[i]
        }

        this.setState({ codigoDigits })

        let ultimoIndex = Math.min(index + chars.length, CODIGO_TAMANHO) - 1
        const ultimoRef = ultimoIndex >= 0 ? this.codigoRefs[ultimoIndex].current : null
        if (ultimoRef) ultimoRef.focus()
    }

    checkPossui2fa = () => {
        const requestURL = cfg.base_api_url + cfg.api_v2 + `/check-2fa/?email=${encodeURIComponent(this.state.email)}`

        return axios.get(requestURL)
            .then((response) => {
                return response.data === true || response.data?.ativo_2fa === true
            })
    }

    generateToken = () => {
        const requestURL = cfg.base_api_url + 'o/token/'
        const config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }

        let bodyFormData = new FormData()
        bodyFormData.append("client_id", cfg.client_id)
        bodyFormData.append("client_secret", cfg.client_secret)
        bodyFormData.append("grant_type", cfg.grant_type)
        bodyFormData.append("username", this.state.email)
        bodyFormData.append("password", this.state.password)

        return axios.post(requestURL, bodyFormData, config)
            .then((res) => {
                auth.setToken(res.data.access_token, true)
                auth.set(res.data.refresh_token, '__hidroview__refresh_token', true)
                auth.set(String(this.state.conexao_persistente), '__hidroview__persist_connect', true)
            })
    }

    getDataUser = () => {
        helper.getLocalStorageMeInfos().then(data => {
            auth.setUserInfo(data, true)
            this.setState({ redirectToReferrer: true, loading: false })
        })
    }

    handleSubmit = async (e) => {
        e.preventDefault()

        if (this.state.loading) return

        this.setState({ loading: true })

        this.checkPossui2fa()
            .then((possui2fa) => {
                if (possui2fa) {
                    this.setState({ step: 2, loading: false })
                } else {
                    this.generateToken()
                        .then(() => {
                            this.getDataUser()
                        })
                        .catch(() => {
                            this.setState({ showmessage: true, loading: false })
                            setTimeout(() => this.setState({ showmessage: false }), 5000)
                        })
                }
            })
            .catch(() => {
                this.setState({ showmessage: true, loading: false })
                setTimeout(() => this.setState({ showmessage: false }), 5000)
            })
    }

    seePassword = () => {
        this.setState({ see_password: !this.state.see_password })
    }

    renderBtnStyle = () => {
        return {
            'background': this.state.cores.login_informacao_background,
            color: this.state.cores.login_formulario_fonte_cor,
            opacity: this.state.loading ? 0.7 : 1,
            cursor: this.state.loading ? 'not-allowed' : 'pointer'
        }
    }

    renderStep = () => {
        const { step, see_password, loading } = this.state
        const type_password = see_password ? "text" : "password"
        const icon_see = see_password ? "las la-eye" : "las la-eye-slash"

        if (step === 2) {
            return (
                <form>
                    <div className="texto-instrucao">Digite abaixo o código de verificação recebido.</div>
                    <div className="codigo-input-group">
                        {this.state.codigoDigits.map((digito, index) => (
                            <input
                                key={index}
                                ref={this.codigoRefs[index]}
                                type="text"
                                inputMode="text"
                                maxLength={1}
                                autoComplete="off"
                                autoFocus={index === 0}
                                value={digito}
                                onChange={(e) => this.handleCodigoDigitChange(index, e)}
                                onKeyDown={(e) => this.handleCodigoDigitKeyDown(index, e)}
                                onPaste={(e) => this.handleCodigoPaste(index, e)}
                            />
                        ))}
                    </div>
                    <div>
                        <div style={this.renderBtnStyle()} className="btn-login" onClick={!loading ? this.validarCodigo2fa : undefined}>{loading ? "Verificando..." : "Confirmar"}</div>
                    </div>
                    <div className="esqueci-minha-senha">
                        <a href="#" onClick={(e) => { e.preventDefault(); this.cancelar2fa() }}>Voltar</a>
                    </div>
                </form>
            )
        }

        return (
            <form>
                <input placeholder="E-mail ..." type="text" id="email" value={this.state.email} onChange={e => this.setState({ email: e.target.value })} onKeyPress={this.handleKeyPress} className="campo-form" />

                <div className="container-login-password">
                    <div className="password">
                        <input placeholder="Senha ..." type={type_password} id="password" value={this.state.password} onChange={e => this.setState({ password: e.target.value })} onKeyPress={this.handleKeyPress} />
                    </div>

                    <div className="see-password">
                        <i onClick={this.seePassword} className={icon_see}></i>
                    </div>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0px 5px" }}>
                    <span>
                        <input onChange={e => this.setState({ conexao_persistente: e.target.checked })} onKeyPress={this.handleKeyPress} type="checkbox" name="permanecer" id="permanecer" />
                        <label htmlFor="permanecer" className="permancer-label">Permanecer conectado?</label>
                    </span>
                    <div className="esqueci-minha-senha"><Link to="/lost-password">Esqueceu sua senha?</Link></div>
                </div>
                <div
                    style={this.renderBtnStyle()}
                    className="btn-login"
                    onClick={!loading ? this.handleSubmit : undefined}>
                    {loading ? "Acessando..." : "Acessar"}
                </div>
            </form>
        )
    }

    render() {
        const { from } = this.props.location.state || { from: { pathname: "/" } }
        const { redirectToReferrer, step } = this.state

        if (redirectToReferrer) {
            return <Redirect to={from} />
        }

        if (auth.getToken() !== null && auth.getUserInfo() !== null) {
            return <Redirect to={from} />
        }

        const titulo = step === 2 ? "Verificação 2FA" : (this.state.config.titulo_sistema ? this.state.config.titulo_sistema : "Acesso ao Sistema")

        return (
            <div className={(this.state.loadcomplete) ? "body-page" : "hdv-noshow-item"} style={{ 'background': `linear-gradient(to right, ${this.state.cores.login_informacao_background} 50%, transparent 50%` }}>
                <div className="container-login" style={{ 'backgroundColor': this.state.cores.login_informacao_background }}>
                    <div className="login-logo-sociais">
                        <div className="logomarca">
                            <img style={{filter: this.state.cores.filtro_logo ? 'brightness(0) invert(1)' : '', maxWidth: "200px"}} src={this.state.logomarca}/>
                        </div>
                    </div>
                    <div className="form-login">

                        <div className="imagem-titulo" style={{ width: "160px", height: "100px", backgroundImage: this.state.logomarca ? `url(${this.state.logomarca})` : 'none', backgroundRepeat: "no-repeat", backgroundPosition: "center", backgroundSize: "cover", margin: "0 auto" }}></div>

                        <div className="titulo">{titulo}</div>

                        {this.renderStep()}
                    </div>
                </div>
            </div>
        )
    }
}

export default Login